import dayjs from 'dayjs'
import i18n from 'src/common/i18n'
import { OffersManagementTab } from '../types'

export interface Filters {
  depositAssets: string[] // Token IDs
  withdrawalAssets: string[] // Token IDs
  offerStatuses: ExpandedOfferFillType[]
  timeRange: number
}

export type Option<T = string> = {
  value: T
  label: string
  tabs?: OffersManagementTab[] // undefined - for all filters
}

export enum ExpandedOfferFillType {
  Cancelled = 'Cancelled',
  FullyTaken = 'FullyTaken',
  NotTaken = 'NotTaken',
  PartiallyTaken = 'PartiallyTaken',
  Expired = 'Expired',
}

export const initialFilters: Filters = {
  depositAssets: [],
  withdrawalAssets: [],
  offerStatuses: [],
  timeRange: 0,
}

export const OfferFillTypeOptions: Option<ExpandedOfferFillType>[] = [
  {
    value: ExpandedOfferFillType.FullyTaken,
    label: i18n.t('offersManagement:offersFilter.offerStatus.fullyTaken'),
  },
  {
    value: ExpandedOfferFillType.PartiallyTaken,
    label: i18n.t('offersManagement:offersFilter.offerStatus.partiallyTaken'),
  },
  {
    value: ExpandedOfferFillType.NotTaken,
    label: i18n.t('offersManagement:offersFilter.offerStatus.notTaken'),
  },
  {
    value: ExpandedOfferFillType.Cancelled,
    label: i18n.t('offersManagement:offersFilter.offerStatus.cancelled'),
  },
  {
    value: ExpandedOfferFillType.Expired,
    label: i18n.t('offersManagement:offersFilter.offerStatus.expired'),
    tabs: ['my'],
  },
]

export const TimeRangeOptions: Option<number>[] = [
  {
    value: dayjs().startOf('day').subtract(30, 'days').unix(),
    label: i18n.t('offersManagement:offersFilter.timeRange.past30Days'),
  },
  {
    value: dayjs().startOf('day').subtract(3, 'months').unix(),
    label: i18n.t('offersManagement:offersFilter.timeRange.past3Months'),
  },
  {
    value: dayjs().startOf('day').subtract(6, 'months').unix(),
    label: i18n.t('offersManagement:offersFilter.timeRange.past6Months'),
  },
  {
    value: dayjs().startOf('day').subtract(1, 'year').unix(),
    label: i18n.t('offersManagement:offersFilter.timeRange.lastYear'),
  },
]
